import { StepIconProps, styled } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'

const CustomStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean }
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.primary.main,
  zIndex: 1,
  color: theme.palette.common.white,
  width: 25,
  height: 25,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    fontSize: '17px'
  },
  ...(ownerState.active && {
    backgroundColor: theme.palette.primary.main
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.action.disabledBackground
  })
}))

export function CustomStepIcon(props: StepIconProps) {
  const { icon, active, completed, className } = props

  return (
    <CustomStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? <CheckIcon /> : icon}
    </CustomStepIconRoot>
  )
}
